





































































































































































































import Vue from "vue";
import {
  MatchingCandidatesStatus,
  MatchingCandidatesSelected,
  PokeCandidatePayload
} from "@/store/modules/recruiter/interfaces";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
  JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
  VIEW_CANDIDATES_DYNAMICALLY,
  MACTHING_CANDIDATE_SHORTLISTED_AND_REJECTED,
  JOB_GENERATION_MATCHING_CANDIDATES,
  CANDIDATE_STATUS_UPDATE,
  POKE_CANDIDATE,
  FETCH_MATCHING_CANDIDATES,
  CANDIDATE_DATA,
  JOB_GENERATION_PROMPT_RESPONSE,
  JOB_SHORT_URL
} from "@/store/modules/recruiter/constants";
import { SearchedCandidate } from "@/store/modules/recruiter/interfaces";
import CandidateDetailCard from "@/components/recruiter/jobs/post_job/ai_generated/CandidateDetailCard.vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import DataNotFound from "@/components/shared/DataNotFound.vue";
import ViewCandidateProfileDialog from "@/views/recruiter/candidates/ViewCandidateProfileDialog.vue";
import AlertBoxDialog from "@/components/shared/AlertBoxDialog.vue";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import ViewCandidateScreeningQuestions from "@/components/recruiter/jobs/ViewCandidateScreeningQuestions.vue";
import { sort_and_filter_candidates } from "@/utils/global";
import { SEND_EMAIL } from "@/store/modules/common/constants";
import { EmailTypes } from "@/interfaces/app.interface";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "AiGeneratedAllCandidates",
  components: {
    CandidateDetailCard,
    GoBackHeader,
    DataNotFound,
    ViewCandidateProfileDialog,
    AlertBoxDialog,
    ViewCandidateScreeningQuestions
  },
  data() {
    return {
      show_candidate: false,
      selected_candidate: {} as SearchedCandidate,
      alert_box: false,
      alert_title: "",
      submit_button_text: "",
      icon: "bold/trash.svg",
      background_color: "rgba(227, 45, 107, 0.1)",
      color_code: "#E32D6B",
      loading: false,
      is_any_candidate_select: false,
      is_view_screening_questions: false,
      local_shortlist_candidate: [] as SearchedCandidate[],
      local_rejected_candidates: [] as SearchedCandidate[],
      local_other_recommendations: [] as SearchedCandidate[],
      job_id: null as number | null,
      items: [...Array(4)].map((_, i) => `Item ${i}`)
    };
  },
  props: {
    is_header_view: {
      type: Boolean,
      default: true
    },
    shortlisted_candidates: {
      type: Array as () => SearchedCandidate[]
    },
    rejected_candidates: {
      type: Array as () => SearchedCandidate[]
    },
    other_recommendations: {
      type: Array as () => SearchedCandidate[]
    },
    screened_assessment_id: {
      type: Number
    }
  },
  watch: {
    shortlisted_candidates: {
      handler() {
        this.set_local_candidates();
      },
      deep: true
    },
    rejected_candidates: {
      handler() {
        this.set_local_candidates();
      },
      deep: true
    },
    other_recommendations: {
      handler() {
        this.set_local_candidates();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters("recruiter", {
      get_accepted_candidates: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES,
      get_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      get_candidate_data: JOB_GENERATION_MATCHING_CANDIDATES,
      get_all_candidates: CANDIDATE_DATA,
      current_status: CANDIDATE_STATUS_UPDATE,
      get_ai_generated_prompt_resp: JOB_GENERATION_PROMPT_RESPONSE
    }),
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    MatchingCandidatesStatus() {
      return MatchingCandidatesStatus;
    },
    get_desired_candidates(): SearchedCandidate[] {
      if (this.current_status === MatchingCandidatesStatus.UNSELECTED)
        return this.local_other_recommendations ?? [];
      else if (this.current_status === MatchingCandidatesStatus.SHORTLISTED)
        return this.local_shortlist_candidate ?? [];
      else if (this.current_status === MatchingCandidatesStatus.REJECTED)
        return this.local_rejected_candidates ?? [];
      else return this.get_all_candidates ?? [];
    }
  },
  mounted() {
    this.set_local_candidates();
  },
  methods: {
    ...mapMutations("recruiter", {
      set_candidates_view_dynamically: VIEW_CANDIDATES_DYNAMICALLY,
      set_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      set_matching_candidates: JOB_GENERATION_MATCHING_CANDIDATES,
      set_current_filter: CANDIDATE_STATUS_UPDATE,
      set_accepted_candidates: JOB_GENERATION_ACCEPTED_MATCHING_CANDIDATES
    }),
    ...mapActions("recruiter", {
      set_shortlisted_and_rejected_candidate:
        MACTHING_CANDIDATE_SHORTLISTED_AND_REJECTED,
      poke_candidate: POKE_CANDIDATE,
      fetch_matching_candidates: FETCH_MATCHING_CANDIDATES,
      get_job_short_url: JOB_SHORT_URL
    }),
    ...mapActions("common", {
      send_email: SEND_EMAIL
    }),
    ...mapMutations({
      root_notication: ROOT_NOTIFICATION,
      root_error: ROOT_ERROR
    }),
    change_filter(status: MatchingCandidatesStatus) {
      this.set_current_filter(status);
      this.set_local_candidates();
      this.check_any_selected();
    },
    view_candidate(search_candidate: SearchedCandidate) {
      const job = search_candidate.job_id;
      const user = search_candidate.candidate_id;
      const upload = search_candidate.upload_response_id;
      if (!job || !user || !upload) return;
      sessionStorage.setItem("job", job.toString());
      sessionStorage.setItem("user", user.toString());
      sessionStorage.setItem("upload", upload.toString());
      this.$router.push("/recruiter/candidates/profile");
    },
    candidate_selected_list(filter: string, index: number) {
      this.set_local_candidates();
      if (this.current_status === MatchingCandidatesStatus.REJECTED) {
        this.local_rejected_candidates[index].selected = filter === "select";
        this.job_id = this.local_rejected_candidates[index].job_id ?? null;
        this.set_rejected_candidates(this.local_rejected_candidates);
      } else if (this.current_status === MatchingCandidatesStatus.UNSELECTED) {
        this.local_other_recommendations[index].selected = filter === "select";
        this.job_id = this.local_other_recommendations[index].job_id ?? null;
        this.set_matching_candidates(this.local_other_recommendations);
      } else {
        this.local_shortlist_candidate[index].selected = filter === "select";
        this.job_id = this.local_shortlist_candidate[index].job_id ?? null;
        this.set_accepted_candidates(this.local_shortlist_candidate);
      }
      this.check_any_selected();
    },
    alert_box_config(filter: string) {
      if (filter === "Reject" || filter === "reject-email") {
        this.alert_title =
          "Are you sure you want to reject selected candidates?";
        this.submit_button_text =
          filter === "Reject" ? "Reject" : "Send Reject Email";
        this.alert_box = true;
        this.icon = "bold/trash.svg";
        this.background_color = "rgba(227, 45, 107, 0.1)";
        this.color_code = "#E32D6B";
      } else {
        this.alert_title = `Are you sure you want to ${filter} selected candidates?`;
        this.submit_button_text = filter;
        this.alert_box = true;
        this.icon = "linear/add-candidate.svg";
        this.background_color = "#ADE3E3";
        this.color_code = "primary";
      }
    },
    async approved_request() {
      this.loading = true;
      let payload = [] as MatchingCandidatesSelected[];
      if (this.current_status === MatchingCandidatesStatus.UNSELECTED) {
        const selected_candidates = this.local_other_recommendations.filter(
          (candidate) => candidate.selected
        );
        if (this.submit_button_text === "Reject") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.REJECTED
            };
          });
        } else if (this.submit_button_text === "Shortlist") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.SHORTLISTED
            };
          });
        }
      } else if (this.current_status === MatchingCandidatesStatus.REJECTED) {
        const selected_candidates = this.local_rejected_candidates.filter(
          (candidate) => candidate.selected
        );
        if (this.submit_button_text === "Unselect") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.REMOVE
            };
          });
        } else if (this.submit_button_text === "Shortlist") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.SHORTLISTED
            };
          });
        } else if (this.submit_button_text === "Send Reject Email") {
          const user_ids = selected_candidates.map(
            (candidate) => candidate.candidate_id
          );
          return await this.sendEmailIntoBulkForm(user_ids, "reject");
        }
      } else {
        const selected_candidates = this.local_shortlist_candidate.filter(
          (candidate) => candidate.selected
        );

        if (this.submit_button_text === "Reject") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.REJECTED
            };
          });
        } else if (this.submit_button_text === "Unselect") {
          payload = selected_candidates.map((candidate) => {
            return {
              job_id: candidate.job_id,
              candidate_id: candidate.candidate_id,
              status: MatchingCandidatesStatus.REMOVE
            };
          });
        } else if (this.submit_button_text === "Send Invite") {
          const user_ids = selected_candidates.map(
            (candidate) => candidate.candidate_id
          );
          return await this.sendEmailIntoBulkForm(user_ids, "invite");
        }
      }
      const result = await this.set_shortlisted_and_rejected_candidate({
        data: payload
      });
      if (result) {
        // this.send_invite_email(payload);  Dont send Email now
        if (this.is_header_view) this.fetch_candidates();
        this.$emit("fetch_candidates");
      }
      this.alert_box = false;
      this.loading = false;
    },
    check_any_selected() {
      if (this.current_status === MatchingCandidatesStatus.UNSELECTED) {
        this.is_any_candidate_select = this.local_other_recommendations.some(
          (candidate) => candidate.selected === true
        );
      } else if (this.current_status === MatchingCandidatesStatus.REJECTED) {
        this.is_any_candidate_select = this.local_rejected_candidates.some(
          (candidate) => candidate.selected === true
        );
      } else if (this.current_status === MatchingCandidatesStatus.SHORTLISTED) {
        this.is_any_candidate_select = this.local_shortlist_candidate.some(
          (candidate) => candidate.selected === true
        );
      }
    },
    async send_invite_email(candidate: MatchingCandidatesSelected[]) {
      const data = candidate.filter(
        (candidate) => candidate.status === MatchingCandidatesStatus.SHORTLISTED
      );
      if (data.length > 0) {
        data.forEach(async (data: MatchingCandidatesSelected) => {
          if (data.job_id) {
            const payload: PokeCandidatePayload = {
              candidate_id: data.candidate_id,
              job_id: data.job_id,
              type: "interview_invite",
              whatsapp: true,
              send_email: false
            };
            await this.poke_candidate(payload);
          }
        });
      }
    },
    view_screening_questions(search_candidate: SearchedCandidate) {
      this.selected_candidate = search_candidate;
      this.is_view_screening_questions = true;
    },
    set_local_candidates() {
      this.local_shortlist_candidate =
        (this.shortlisted_candidates || this.get_accepted_candidates) ?? [];
      this.local_rejected_candidates =
        (this.rejected_candidates || this.get_rejected_candidates) ?? [];
      this.local_other_recommendations =
        (this.other_recommendations || this.get_candidate_data) ?? [];
    },
    async fetch_candidates() {
      if (this.job_id) {
        const matching_candidates = (await this.fetch_matching_candidates({
          job_ids: [this.job_id]
        })) as any;

        if (matching_candidates && matching_candidates?.results) {
          this.set_matching_candidates([]);
          this.set_rejected_candidates([]);
          this.set_accepted_candidates([]);

          this.local_other_recommendations = [];
          this.local_rejected_candidates = [];
          this.local_shortlist_candidate = [];
          const data = matching_candidates.results;

          data.forEach((item: any) => {
            if (
              item.matching_candidate_status ===
              MatchingCandidatesStatus.REJECTED
            )
              this.local_rejected_candidates.push(item);
            else if (
              item.matching_candidate_status ===
              MatchingCandidatesStatus.SHORTLISTED
            )
              this.local_shortlist_candidate.push(item);
            else this.local_other_recommendations.push(item);
          });

          const rejected_candidates = sort_and_filter_candidates(
            this.local_rejected_candidates
          );
          const shortlisted_candidates = sort_and_filter_candidates(
            this.local_shortlist_candidate
          );
          const other_recommendations = sort_and_filter_candidates(
            this.local_other_recommendations
          );

          this.set_matching_candidates(other_recommendations);
          this.set_rejected_candidates(rejected_candidates);
          this.set_accepted_candidates(shortlisted_candidates);
        }
      }
    },
    async sendEmailIntoBulkForm(user_ids: number[], type: string) {
      const jid = this.get_ai_generated_prompt_resp?.job_id;
      try {
        const url = "";
        const payload = {
          user_ids: user_ids,
          type:
            type === "invite" ? EmailTypes.BULK_INVITE : EmailTypes.BULK_REJECT,
          job: {
            jid: jid,
            title: this.get_ai_generated_prompt_resp?.job_title,
            description: this.get_ai_generated_prompt_resp?.job_description,
            link: url ?? `/recruiter/jobs/${jid}`
          }
        };

        const result = await this.send_email(payload);
        if (result) {
          this.clear_selected_action();
          this.root_notication("Emails sent successfully");
        }
      } catch (error) {
        this.root_error("Failed to send email");
      }
      this.alert_box = false;
      this.loading = false;
    },
    async generate_short_url(jobId: number) {
      const obj = {
        job_id: jobId,
        job_url: `https://${window.location.hostname}/public/job`
      };
      const response = await this.get_job_short_url(obj);
      return response.url ? response.url : undefined;
    },
    on_cancel() {
      this.alert_box = false;
      this.loading = false;
    },
    clear_selected_action() {
      if (this.current_status === MatchingCandidatesStatus.UNSELECTED) {
        this.local_other_recommendations.forEach((candidate, index) => {
          this.$set(this.local_other_recommendations, index, {
            ...candidate,
            selected: false
          });
        });
        this.set_matching_candidates(this.local_other_recommendations);
      } else if (this.current_status === MatchingCandidatesStatus.REJECTED) {
        this.local_rejected_candidates.forEach((candidate, index) => {
          this.$set(this.local_rejected_candidates, index, {
            ...candidate,
            selected: false
          });
        });
        this.set_rejected_candidates(this.local_rejected_candidates);
      } else if (this.current_status === MatchingCandidatesStatus.SHORTLISTED) {
        this.local_shortlist_candidate.forEach((candidate, index) => {
          this.$set(this.local_shortlist_candidate, index, {
            ...candidate,
            selected: false
          });
        });
        this.set_accepted_candidates(this.local_shortlist_candidate);
      }
      this.is_any_candidate_select = false;
      this.set_local_candidates();
    }
  }
});
